<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main material-modal">
      <div class="title-area" id="modal-moving">
        <h2>カウンター/サーフェス収まり設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="main-area">
        <span>{{ spaceObjName + '（id:' + form.spaceId + '）'}}</span>
        <div class="top-input">
          {{faceData.face3.name}}
          <input type="number" v-if="dir===1" v-model="form.valueBack">
          <input type="number" v-else v-model="form.valueTop">
        </div>
        <div class="data-area">
          <div class="side-input">
            {{faceData.face6.name}}
            <input type="number" v-if="dir===2" v-model="form.valueBack">
            <input type="number" v-else v-model="form.valueLeft">
          </div>
          <div class="unit-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <!-- ユニット -->
              <rect
                :x="(this.svgSize - previewData.width) / 2"
                :y="(this.svgSize - previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
            </svg>
          </div>
          <div class="side-input">
            {{faceData.face4.name}}
            <input type="number" v-if="dir===2" v-model="form.valueFront">
            <input type="number" v-else v-model="form.valueRight">
          </div>
        </div>
        <div>
          {{faceData.face5.name}}
          <input type="number" v-if="dir===1" v-model="form.valueFront">
          <input type="number" v-else v-model="form.valueBottom">
        </div>
      </div>
      <div class="errormessage-area">
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateSurfaceLedge">登録</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {ATTRIBUTE_KEY} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetSurfaceLedgeModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      form: {
        spaceId: '',
        valueRight: 0,
        valueLeft: 0,
        valueTop: 0,
        valueBottom: 0,
        valueFront: 0,
        valueBack: 0
      },
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      /** 配列方向 */
      dir: '',
      /** アトリビュート情報 */
      ledgeAtt: {},
      /** プレビュー表示用データ */
      previewData: {
        width: '',
        height: '',
        processX: '',
        processY: '',
        processRX: '',
        processRY: '',
        processW: '',
        processH: ''
      },
      /** プレビュー表示エリアサイズ */
      svgSize: 350,
      /** プレビュー縮尺率 */
      previewRatio: 1,
      /** フォントサイズ */
      fontSize: 12,
      /** 表示対象面 */
      faceData: {
        face1: {
          name: '',
          code: ''
        },
        face2: {
          name: '',
          code: ''
        },
        face3: {
          name: '',
          code: ''
        },
        face4: {
          name: '',
          code: ''
        },
        face5: {
          name: '',
          code: ''
        },
        face6: {
          name: '',
          code: ''
        }
      },
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    dispViewBox: function () {
      return 0 + ' ' + 0 + ' ' + this.svgSize + ' ' + this.svgSize
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 収まり設定モーダル表示 */
    showModal: function () {
      this.clearData()
      this.form.spaceId = this.focusedMenuSpace != null ? this.focusedMenuSpace.id : this.editCtrlSpaces[0].id
      this.getPartsData()
      this.showPartsPreview()
      this.modalShown = true
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** パーツ情報の取得 */
    getPartsData: function () {
      this.selectedSpace = SpaceUtil.searchSpaceTree(this.form.spaceId, this.fileData.topSpaceModel)
      // 収まり設定
      this.ledgeAtt = this.fileData.attributeModelList.find(att => {
        return [ATTRIBUTE_KEY.UT_COUNTER_LEDGE, ATTRIBUTE_KEY.UT_SURFACE_LEDGE].includes(att.attKeycd) && att.spaceId === this.form.spaceId
      })
      let partsSpace = this.selectedSpace.childrenSpaceModel[0]
      // パーツの向き設定
      let dirAtt = this.fileData.attributeModelList.find(att => {
        return att.attKeycd === ATTRIBUTE_KEY.PT_FLAG_DIR && att.spaceId === partsSpace.id
      })
      this.dir = dirAtt.attValue1
      this.spaceObjName = this.fileData.objectDataModelList.find(obj => {
        return obj.spaceId === this.form.spaceId
      }).objName
      // 表示用の面の設定
      switch (this.dir) {
        case 1:
          this.faceData.face1 = {name: '上', code: 3}
          this.faceData.face2 = {name: '下', code: 4}
          this.faceData.face3 = {name: '後', code: 6}
          this.faceData.face4 = {name: '右', code: 1}
          this.faceData.face5 = {name: '前', code: 5}
          this.faceData.face6 = {name: '左', code: 2}
          break
        case 2:
          this.faceData.face1 = {name: '左', code: 2}
          this.faceData.face2 = {name: '右', code: 1}
          this.faceData.face3 = {name: '上', code: 3}
          this.faceData.face4 = {name: '前', code: 5}
          this.faceData.face5 = {name: '下', code: 4}
          this.faceData.face6 = {name: '後', code: 6}
          break
        case 3:
          this.faceData.face1 = {name: '前', code: 5}
          this.faceData.face2 = {name: '後', code: 6}
          this.faceData.face3 = {name: '上', code: 3}
          this.faceData.face4 = {name: '右', code: 1}
          this.faceData.face5 = {name: '下', code: 4}
          this.faceData.face6 = {name: '左', code: 2}
          break
        default:
      }
      this.getSurfaceLedgeData()
    },
    /** 素材情報情報の取得 */
    getSurfaceLedgeData: function () {
      this.form.valueRight = this.ledgeAtt != null ? this.ledgeAtt.attDouble1 : 0
      this.form.valueLeft = this.ledgeAtt != null ? this.ledgeAtt.attDouble2 : 0
      this.form.valueTop = this.ledgeAtt != null ? this.ledgeAtt.attDouble3 : 0
      this.form.valueBottom = this.ledgeAtt != null ? this.ledgeAtt.attDouble4 : 0
      this.form.valueFront = this.ledgeAtt != null ? this.ledgeAtt.attDouble5 : 0
      this.form.valueBack = this.ledgeAtt != null ? this.ledgeAtt.attDouble6 : 0
    },
    /** 収まり情報の更新 */
    updateSurfaceLedge: function () {
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/surface-ledge/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          AppUtil.showModal({
            messages: ['変更しました。']
          })
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** パーツのプレビュー表示 */
    showPartsPreview: function () {
      switch (this.dir) {
        case 1:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.d
          break
        case 2:
          this.previewData.width = this.selectedSpace.d
          this.previewData.height = this.selectedSpace.h
          break
        case 3:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.h
          break
        default:
      }
      this.calcPreviewRatio()
      this.previewData.width = this.previewData.width * this.previewRatio
      this.previewData.height = this.previewData.height * this.previewRatio
    },
    /** 縮尺率の計算 */
    calcPreviewRatio: function () {
      if (this.previewData.width > this.svgSize * 0.9 || this.previewData.height > this.svgSize * 0.9) {
        let widthRatio = this.svgSize / this.previewData.width
        let heightRatio = this.svgSize / this.previewData.height
        this.previewRatio = widthRatio > heightRatio ? heightRatio * 0.9 : widthRatio * 0.9
      } else {
        this.previewRatio = 0.9
      }
    },
    clearData: function () {
      this.form = {
        spaceId: '',
        valueRight: 0,
        valueLeft: 0,
        valueTop: 0,
        valueBottom: 0,
        valueFront: 0,
        valueBack: 0
      }
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.material-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
  margin: 10px auto;
  input{
    width: 100px;
  }
  .top-input {
    margin-top: 30px;
  }
}
.data-area{
  display: flex;
  width: 100%;
  .side-input {
    width: 25%;
    padding: 160px 0;
  }
  .unit-area {
    width: 50%;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 75px;
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetSurfaceLedgeModal.vue